// extracted by mini-css-extract-plugin
module.exports = {"calendar__month":"Month_calendar__month__HXmdf","calendar__week":"Month_calendar__week__1p6RN"};